import { render, staticRenderFns } from "./CafeReportContent.vue?vue&type=template&id=5a235903"
import script from "./CafeReportContent.vue?vue&type=script&lang=js"
export * from "./CafeReportContent.vue?vue&type=script&lang=js"
import style0 from "./CafeReportContent.vue?vue&type=style&index=0&id=5a235903&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports